module.exports = __webpack_public_path__ + "img/code.9e1a7705.png";